module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-13-0a317a90603bad4f6b664508b79f8cac.svg";